import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Material UI
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { withStyles } from '@material-ui/core/styles';

import CopyLink from './copy-link';
import * as ErrorCodeUtils from '../../shared/error-code-utils';

const fieldWidth = '500px';

const styles = theme => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        [theme.breakpoints.up('md')]: {
            width: fieldWidth
        }
    },
    fab: {
        marginBottom: theme.spacing(2)
    }
});

const ErrorModalBase = ({
    classes,
    errorModalOpen,
    errorResponse,
    onCloseModal,
    showDatadogTraceUrl
}) => {
    const traceId = _.get(errorResponse, ['data', 'traceId'], null);
    const datadogTraceUrl = _.get(errorResponse, ['data', 'datadogTraceUrl'], null);
    const errorMessage = ErrorCodeUtils.getErrorResponseMessage(errorResponse);

    return (
        <Dialog
            open={errorModalOpen}
            onClose={onCloseModal}
            maxWidth={false}
            PaperProps={{ style: { width: fieldWidth } }}>
            <DialogTitle>Error</DialogTitle>
            <DialogContent>
                <Typography variant='body1' paragraph>{errorMessage}</Typography>
                {!_.isNil(traceId) && <Typography variant='body1' paragraph>
                    <Typography component='span'>
                        trace_id:<br /><code>{traceId}</code>
                    </Typography>
                    {' '}(<CopyLink stringToCopy={traceId} linkText='copy trace_id'/>)
                </Typography>}
                {showDatadogTraceUrl && !_.isNil(datadogTraceUrl) && <Typography variant='body1' paragraph>
                    <Typography component='span'>
                        Datadog Trace URL:<br /><code>{datadogTraceUrl}</code>
                    </Typography>
                    {' '}(<CopyLink stringToCopy={datadogTraceUrl} linkText='copy URL'/>)
                </Typography>}
            </DialogContent>
            <DialogActions>
                <Fab
                    className={classes.fab}
                    color='primary'
                    size='medium'
                    variant='extended'
                    style={{ textTransform: 'none' }}
                    onClick={onCloseModal}>
                    <CheckCircleOutlineIcon />
                    Acknowledge
                </Fab>
            </DialogActions>
        </Dialog>
    );
};

ErrorModalBase.propTypes = {
    classes: PropTypes.object.isRequired,
    errorResponse: PropTypes.shape({
        data: PropTypes.shape({
            error: PropTypes.string,
            stack: PropTypes.arrayOf(PropTypes.string),
            statusCode: PropTypes.number,
            traceId: PropTypes.string
        })
    }),
    errorModalOpen: PropTypes.bool,
    onCloseModal: PropTypes.func.isRequired,
    showDatadogTraceUrl: PropTypes.bool
};

ErrorModalBase.defaultProps = {
    errorModalOpen: false,
    errorResponse: {},
    onCloseModal: _.noop,
    setDatadogTraceFilter: _.noop,
    showDatadogTraceUrl: false
};

const ErrorModal = withStyles(styles)(ErrorModalBase);

export default ErrorModal;
